import React from "react";
import { Column } from "components/Table/Table";
import { CompanyUser } from "generated/graphql";
import { formatPhoneNumber } from "utils";
import useText from "constants/text";

export const useUserListRows = (): Column<Partial<CompanyUser>>[] => {
  const { text } = useText();
  return [
    {
      field: "company_user_email",
      title: `${text.all.email}`,
    },
    {
      field: "company_user_firstname",
      title: `${text.all.first_name}`,
    },
    {
      field: "company_user_lastname",
      title: `${text.all.last_name}`,
    },
    {
      field: "company_user_phone_number",
      title: `${text.all.phone_number}`,
      render: ({ company_user_phone_number }) => (
        <> {formatPhoneNumber(company_user_phone_number)}</>
      ),
    },
    {
      field: "company_user_job",
      title: `${text.user.user_role}`,
    },
    {
      field: "company_user_profil",
      title: `${text.all.profile}`,
    },
  ];
};
